import {FC} from 'react';

import {Box, CircularProgress} from '@mui/material';

const Fallback: FC = () => {
  return (
    <Box
      sx={{
        width: 'calc(100% - 32px)',
        height: 'calc(100% - 64px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Fallback;
